(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/common/assets/javascripts/constants/sub-product-ids.js') >= 0) return;  svs.modules.push('/components/payment/common/assets/javascripts/constants/sub-product-ids.js');
"use strict";

const subProductIds = {
  VMTIPSET: 3,
  EMTIPSET: 4
};
setGlobal('svs.components.payment.common.constants.subProductIds', subProductIds);

 })(window);